/*
 * @Author: xgj
 * @Date: 2022-09-16 14:17:12
 * @LastEditors: xgj
 * @LastEditTime: 2022-09-16 14:25:23
 * @Description: 
 * @FilePath: /yifei-pc/src/components/common/payDialog.js
 */
import Vue from "vue"
import customDialog from './components/datav/DialogEmpty.vue';


const EditionPayDialogConstructor = Vue.extend(customDialog) //通过Vue下的extend方法可以得到组件构造函数//Tip是引入进来的组件对象

export function EditionPayDialog(options) { //通过函数创建组件
  const EditionPaycom = new EditionPayDialogConstructor({
    data: options
  }).$mount() //new EditionPayDialog的结果得到vue组件对象 //xx.$mount() 放置渲染出来的dom，并将dom挂载到属性上
  document.body.appendChild(EditionPaycom.$el) //EditionPaycom是个组件对象，EditionPay.$el是组件对象渲染出来的dom
}
